import { SellerSelector } from '../components/seller-selector.component'
import { useAuthStore } from '../stores/auth.store'
import { type HTMLAttributes, type ReactNode, useEffect } from 'react'

import { Footer } from '../components/footer.component'
import { Header } from '../components/header.component'
import { ModalConfirmComponent } from '../components/modal-confirm.component'
import { ModalLoadingComponent } from '../components/modal-loading.component'
import { useAuth } from '../hooks/use-auth'
import { cn } from '../lib/utils'
import { useMainStore } from '../stores/main.store'
import { useCheckNewVersion } from '../hooks/use-check-new-version.hook'

type LayoutProps = HTMLAttributes<HTMLDivElement> & {
	children: ReactNode
	isDrawer?: boolean
	pageTitle: string
  hasSellerFilter?: boolean
	hiddenFotters?: boolean
	handleGoBack?: () => void
}
export function Layout({
	children,
  hasSellerFilter = false,
	isDrawer,
	pageTitle,
	handleGoBack,
	hiddenFotters,
	className,
	...rest
}: LayoutProps) {
	const { user, versionApp } = useAuth()
  const nivelAcesso = useAuthStore((state) => state.nivelAcesso)
  const showSellerFilter = hasSellerFilter && nivelAcesso === 3
	const { confirmation } = useMainStore()

	useCheckNewVersion()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return (
		<>
			<div className={cn(' bg-[#F0F2F6] dark:bg-background h-dvh')}>
				<Header
					pageTitle={pageTitle}
          sellerSelector={showSellerFilter ? <SellerSelector /> : undefined}
					isDrawer={isDrawer}
					nameCompany={user?.empresaNome}
					nameSeller={user?.vendedor}
					versionApp={versionApp}
					handleGoBack={handleGoBack}
				/>
				<div
					className={cn(
						'max-w-screen pt-14 px-3 md:max-w-(--breakpoint-2xl) mx-auto mt-3',
						className,
            showSellerFilter && 'pt-40',
					)}
					{...rest}
				>
					{children}
					{hiddenFotters ? (
						<div className="text-center text-sm text-gray-500 pb-16 md:p-2" />
					) : (
						<Footer />
					)}
				</div>
			</div>

			<ModalConfirmComponent
				message={confirmation.message}
				onClose={confirmation.onClose}
				onConfirm={confirmation.onConfirm}
				title={confirmation.title}
				isOpen={confirmation.isOpen}
				timeout={confirmation.timeout}
			/>

			<ModalLoadingComponent />
		</>
	)
}
